import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import axios from "axios";
import { toInteger } from "lodash";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { post, put } from "~/Services";
import { centralizedHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { appendSasToken, removeSasFromDescription } from "../../Imagehelper";
import { fields } from "../constants";
import { usePageDocumentDetails } from "./Type.hooks";

export const CentralizedAddEditType = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const [records, setRecords] = useState<any[]>([]);

  const {
    data: editPageContent,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchCategories,
  } = usePageDocumentDetails(query.get("editId") || "");

  const {
    data: editPageContentById,
    isLoading: isLoadingLocs,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  const [currentAirport] = useLocalStorage("currentAirport", null);

  useEffect(() => {
    const activeTab = query.get("activeTab");
    if (activeTab === "pageHeading") {
      refetchCategories();
    }
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchCategories();
    }
  }, [query.get("activeTab"), query.get("editId"), query.get("id")]);

  const getRecords = () => {
    let url = `${centralizedHost}/api/type-shop-dine`;
    axios
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data;
          setRecords(envelopes);
        }
      })
      .catch(() => {
        setRecords([]);
      });
  };

  useEffect(() => {
    getRecords();
  }, []);

  const formConfig: FormConfig = {
    initialValues: {
      image: editPageContentById
        ? editPageContentById.payload?.image
          ? [
              {
                uid: "-1",
                name: "image.jpg",
                status: "done",
                url: appendSasToken(editPageContentById.payload.image),
              },
            ]
          : []
        : editPageContent?.image
          ? [
              {
                uid: "-1",
                name: "image.jpg",
                status: "done",
                url: appendSasToken(editPageContent.image),
              },
            ]
          : [],

      type_banner_image: editPageContentById
        ? editPageContentById.payload?.type_banner_image
          ? [
              {
                uid: "-1",
                name: "type_banner_image.jpg",
                status: "done",
                url: appendSasToken(editPageContentById.payload.type_banner_image),
              },
            ]
          : []
        : editPageContent?.type_banner_image
          ? [
              {
                uid: "-1",
                name: "type_banner_image.jpg",
                status: "done",
                url: appendSasToken(editPageContent.type_banner_image),
              },
            ]
          : [],

      mobile_image: editPageContentById
        ? editPageContentById.payload?.mobile_image
          ? [
              {
                uid: "-1",
                name: "mobile_image.jpg",
                status: "done",
                url: appendSasToken(editPageContentById.payload.mobile_image),
              },
            ]
          : []
        : editPageContent?.mobile_image
          ? [
              {
                uid: "-1",
                name: "mobile_image.jpg",
                status: "done",
                url: appendSasToken(editPageContent.mobile_image),
              },
            ]
          : [],

      mobile_banner_image: editPageContentById
        ? editPageContentById.payload?.mobile_banner_image
          ? [
              {
                uid: "-1",
                name: "mobile_banner_image.jpg",
                status: "done",
                url: appendSasToken(editPageContentById.payload.mobile_banner_image),
              },
            ]
          : []
        : editPageContent?.mobile_banner_image
          ? [
              {
                uid: "-1",
                name: "mobile_banner_image.jpg",
                status: "done",
                url: appendSasToken(editPageContent.mobile_banner_image),
              },
            ]
          : [],

      name: editPageContentById
        ? decodeHTML(editPageContentById.payload?.name)
        : editPageContent
          ? decodeHTML(editPageContent?.name)
          : "",

      name_malay: editPageContentById
        ? decodeHTML(editPageContentById.payload?.name_malay)
        : editPageContent
          ? decodeHTML(editPageContent?.name_malay)
          : "",

      name_mandarin: editPageContentById
        ? decodeHTML(editPageContentById.payload?.name_mandarin)
        : editPageContent
          ? decodeHTML(editPageContent?.name_mandarin)
          : "",

      label: editPageContentById
        ? decodeHTML(editPageContentById.payload?.label)
        : editPageContent
          ? decodeHTML(editPageContent?.label)
          : "",

      description: editPageContentById
        ? decodeHTML(editPageContentById.payload?.description)
        : editPageContent
          ? decodeHTML(editPageContent?.description)
          : "",

      description_malay: editPageContentById
        ? decodeHTML(editPageContentById.payload?.description_malay)
        : editPageContent
          ? decodeHTML(editPageContent?.description_malay)
          : "",

      description_mandarin: editPageContentById
        ? decodeHTML(editPageContentById.payload?.description_mandarin)
        : editPageContent
          ? decodeHTML(editPageContent?.description_mandarin)
          : "",

      type_description_en: editPageContentById
        ? decodeHTML(editPageContentById.payload?.type_description_en)
        : editPageContent
          ? decodeHTML(editPageContent?.type_description_en)
          : "",

      type_description_ms: editPageContentById
        ? decodeHTML(editPageContentById.payload?.type_description_ms)
        : editPageContent
          ? decodeHTML(editPageContent?.type_description_ms)
          : "",

      type_description_zh: editPageContentById
        ? decodeHTML(editPageContentById.payload?.type_description_zh)
        : editPageContent
          ? decodeHTML(editPageContent?.type_description_zh)
          : "",

      button_text: editPageContentById
        ? decodeHTML(editPageContentById.payload?.button_text)
        : editPageContent
          ? decodeHTML(editPageContent?.button_text)
          : "",

      redirect_url: editPageContentById
        ? decodeHTML(editPageContentById.payload?.redirect_url)
        : editPageContent
          ? decodeHTML(editPageContent?.redirect_url)
          : "",

      project_airport_id: editPageContentById
        ? decodeHTML(editPageContentById.payload.project_airport_id)
        : editPageContent
          ? decodeHTML(editPageContent?.project_airport_id)
          : "",

      sequence: editPageContentById
        ? decodeHTML(editPageContentById.payload.sequence)
        : editPageContent
          ? decodeHTML(editPageContent?.sequence)
          : "",

      published: editPageContentById
        ? decodeHTML(editPageContentById.payload?.published)
        : editPageContent
          ? decodeHTML(editPageContent?.published)
          : "",
    },

    // fields: fields.centralizedType,

    fields: fields.centralizedType.map((field: any) => {
      if (field.name === "sequence") {
        return {
          ...field,
          validation: {
            required: `${field.label || field.name} is required`,
            validate: (value: string, formValues: FieldValues) => {
              if (!value) return true;

              const selectedAirports = formValues.project_airport_id || [];

              const existingRecord = records.find((record: any) => {
                const sameSequence = toInteger(record.sequence) === toInteger(value);

                const isSameRecord = record.id === (editPageContent?.id || editPageContentById?.payload?.id);

                const airportOverlap = record.project_airport_id?.some((airportId: string) =>
                  selectedAirports.includes(airportId)
                );

                return sameSequence && airportOverlap && !isSameRecord;
              });

              return !existingRecord || `${field.label || field.name} already exists for selected airport`;
            },
          },
        };
      }
      return field;
    }),
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["image", "type_banner_image", "mobile_image", "mobile_banner_image"];

    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CENTRALIZED");
          const res: any = await post("management/upload-file", formData);
          if (res) data[key] = res.response.data;
        } else if (field?.[0]?.url) {
          const cleanUrl = field[0].url.split("?sp=")[0];
          data[key] = cleanUrl;
        } else if (Array.isArray(field) && field.length === 0) {
          data[key] = "";
        } else if (!field) {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }

    let descriptionKeys: any = [
      "description",
      "description_malay",
      "description_mandarin",
      "type_description_en",
      "type_description_ms",
      "type_description_zh",
    ];
    for (const key of descriptionKeys) {
      if (data[key]) {
        data[key] = removeSasFromDescription(data[key]);
      }
    }

    if (!data.redirect_url || data.redirect_url.trim() === "") {
      data.redirect_url = `shop-dine-services/${data.name}`;
    }

    const payload = {
      action,
      method,
      module: "Centralized Shop & Dine",
      subModule: "centralizedType",
      type: "CENTRALIZED",
      application: "CENTRALIZED",
      reviewNotes,
      appList: [{ appName: "CENTRALIZED", apiUrl }],
      payload: {
        ...(action === "UPDATE" && {
          id: editPageContent?.id || editPageContentById?.payload?.id,
        }),
        ...data,
        field_category_map_field_malay:
          editPageContent?.field_category_map_field_malay ??
          editPageContentById?.payload?.field_category_map_field_malay ??
          "",

        field_category_map_field:
          editPageContent?.field_category_map_field ?? editPageContentById?.payload?.field_category_map_field ?? "",

        field_category_map_field_mandria:
          editPageContent?.field_category_map_field_mandria ??
          editPageContentById?.payload?.field_category_map_field_mandria ??
          "",
        segregate: "shopanddine",
      },
      status,
    };

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/centralized/status-information?activeTab=pending");
          } else {
            navigate("/centralized/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post(`/management/publish`, payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/centralized/status-information?activeTab=pending");
          } else {
            navigate("/centralized/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Type`}
      showBack
    >
      <DynamicForm
        isLoading={drilldownLoading || isLoadingLocs}
        config={formConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") || query.get("type") === "update" ? `${centralizedHost}/api/type/${editPageContent?.id || editPageContentById?.payload?.id}` : `${centralizedHost}/api/type`}`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Shop & Dine"
      />
    </ContentWrapper>
  );
};
